<div class="card">
  <div>
    <h2 class="documentation-title">Orígenes de fondos</h2>
    <p class="documentation-subtitle">
      Para aumentar tu límite de operación, tenés que subir orígenes de fondos, certificación
      contable y alta del impuesto cedular.
    </p>
    <div class="document-status">
      <div class="document">
        <p class="name">Origen de fondos</p>
        <p
          class="status"
          [ngClass]="getDocumentStatusClass(authService.loggedUser.fundsDocuments.funds)"
        >
          {{ getDocumentStatus(authService.loggedUser.fundsDocuments.funds) }}
        </p>
      </div>
      <div class="document">
        <p class="name">Certificación contable</p>
        <p
          class="status"
          [ngClass]="
            getDocumentStatusClass(authService.loggedUser.fundsDocuments.certificacionContable)
          "
        >
          {{ getDocumentStatus(authService.loggedUser.fundsDocuments.certificacionContable) }}
        </p>
      </div>
      <div class="document">
        <p class="name">Alta del impuesto cedular</p>
        <p
          class="status"
          [ngClass]="getDocumentStatusClass(authService.loggedUser.fundsDocuments.impuestoCedular)"
        >
          {{ getDocumentStatus(authService.loggedUser.fundsDocuments.impuestoCedular) }}
        </p>
      </div>
    </div>
    <button
      *ngIf="showUploadButton()"
      class="td-btn-sm primary documentation-btn"
      (click)="openDocumentFlowDialog()"
    >
      Presentar documentación
    </button>
    <div class="faq">
      ¿Necesitás ayuda? Accedé a
      <a
        href="https://ayuda.tiendacrypto.com/es/article/como-puedo-aumentar-mis-limites-ckhnro/"
        target="_blank"
        >este link </a
      >.
    </div>
    <app-reminder-message
      message="No se acepta constancia de monotributo o autónomos como justificación de orígenes de fondos, en esos caso se deberá aportar documentación complementaria.
      La resolución sobre la documentación presentada la recibís en tu email, dentro de las 24 hs hábiles siguientes."
      type="warning"
    >
    </app-reminder-message>
  </div>
</div>
